import React from 'react';
import PropTypes from "prop-types";
import {useHistory } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
    tittle:{
        marginTop: "-10px",
        marginBottom: "-10px", 
        fontWeight:300,
    }
}));
export default function Titulo (props){
    const history = useHistory();
    const classes = useStyles();
    return (
        <>
        {props.titulo ?
            <>
                <h2 className={classes.tittle}>
                    {props.titulo}
                </h2>
            </>
        : null
        }
        </>
    );
}
Titulo.propTypes = {
    children: PropTypes.node,
};
